declare const __STATIC_RELEASE_ID__: string;

export interface StaticReleaseAsset {
  readonly id: string;
  readonly url: string;
  readonly sha256: string;
  readonly mimeType: string;
  readonly byteLength: number;
  readonly dependencies: readonly string[];
}

export interface StaticReleaseManifest {
  readonly schemaVersion: 1;
  readonly releaseId: string;
  readonly assets: readonly StaticReleaseAsset[];
}

const releaseId = typeof __STATIC_RELEASE_ID__ === 'string' ? __STATIC_RELEASE_ID__ : '';

/** The running bundle pins its static release; it never follows a mutable latest pointer. */
export const STATIC_RELEASE_MANIFEST_URL = releaseId
  ? `/releases/${releaseId}/static-manifest.json`
  : '/static-manifest.json';

export function resolveStaticAssetUrl(assetPath: string): string {
  if (!assetPath.startsWith('/assets/') || /[?#\\]/.test(assetPath)
    || assetPath.split('/').some((part) => part === '..' || part === '.')) {
    throw new Error(`Expected a canonical public asset path: ${assetPath}`);
  }
  return releaseId ? `/releases/${releaseId}${assetPath}` : assetPath;
}
